import React from 'react';
import './ImageStrip.css';
import Image from 'next/image';

interface ImageStripProps {
  items: Object[];
}

export default function ImageStrip(props: ImageStripProps) {
  const { items } = props;
  return (
    <div className="image-strip mb-2">
      {items.map((item:any) => {
        return (
          <div key={item.sys.id}>
            <Image src={item.url} alt={item.alt} width={800} height={400} />
          </div>
        )
      })}
    </div>
  );
}